if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      this.form.querySelector('[name=id]').disabled = false;
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      this.submitButton = this.querySelector('[type="submit"]');
      if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

      this.hideErrors = this.dataset.hideErrors === 'true';
    }

    onSubmitHandler(evt) {
      evt.preventDefault();
      if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

      this.handleErrorMessage();

      const formData = new FormData(this.form);
      const variantId = formData.get('id');
      const quantity = parseInt(formData.get('quantity')) || 1;
      const properties = {};

      // Extract properties from form data
      for (const [key, value] of formData.entries()) {
        if (key.startsWith('properties[') && key.endsWith(']')) {
          const propKey = key.slice(11, -1);
          properties[propKey] = value;
        }
      }

      // Use unified cart utility
      window.CartUtils.addToCart({
        id: variantId,
        quantity: quantity,
        properties: properties,
        context: 'product-form',
        onLoading: (isLoading) => {
          if (isLoading) {
            this.submitButton.setAttribute('aria-disabled', true);
            this.submitButton.classList.add('loading');
            this.querySelector('.loading-overlay__spinner').classList.remove('hidden');
          } else {
            this.submitButton.classList.remove('loading');
            this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading-overlay__spinner').classList.add('hidden');
          }
        },
        onSuccess: (data) => {
          this.error = false;
          if (typeof FM !== 'undefined' && FM.trackCustomEvent) {
    FM.trackCustomEvent('Add to Cart', {
      product_id: variantId,
      quantity: quantity,
      page: window.location.pathname,
      timestamp: new Date().toISOString()
    });
  }
          
          // Publish cart update event
          publish(PUB_SUB_EVENTS.cartUpdate, {source: 'product-form', productVariantId: variantId});
          
          // Handle quick add modal
          const quickAddModal = this.closest('quick-add-modal');
          if (quickAddModal) {
            quickAddModal.hide(true);
          }
          
          // Redirect to cart or show success
          if (!this.cart) {
            window.location = window.routes.cart_url;
          } else {
            // Trigger cart update for cart drawer/notification
            const event = new CustomEvent('cart:updated', {
              detail: { data, timestamp: Date.now() }
            });
            document.dispatchEvent(event);
          }
        },
        onError: (errorData) => {
          publish(PUB_SUB_EVENTS.cartError, {source: 'product-form', productVariantId: variantId, errors: errorData.description, message: errorData.message});
          this.handleErrorMessage(errorData.description);

          const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
          if (!soldOutMessage) return;
          this.submitButton.setAttribute('aria-disabled', true);
          this.submitButton.querySelector('span').classList.add('hidden');
          soldOutMessage.classList.remove('hidden');
          this.error = true;
        }
      });
    }

    handleErrorMessage(errorMessage = false) {
      if (this.hideErrors) return;

      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}
